export default __webpack_public_path__ + "static/media/turn-phone.2bda89b2.svg";